// SimilarCryptos
export const similarCryptos = state => state.similarCryptos;
export const similarCryptosPage = state => state.similarCryptosPage;
export const similarCryptosError = state => state.similarCryptosError;
export const similarCryptosLoading = state => state.similarCryptosLoading;
export const isViewMoreVisible = state => state.isViewMoreVisible;
